import type { PartialRecord } from "@base/util/TypeUtil";

export enum Access {
  Public = 0,
  Private = 1,
  Customer = 2,
  Monteur = 5,
  Dealer = 10,
  DealerBeta = 15,
  Soliday = 40,
  SolidayPro = 45,
  SolidayAdmin = 50,
  Dev = 80,
  FluchtpunktAdmin = 100,
}

export enum AccessFeature {
  ChangeUserAccess = "u",
  ChangeResponsibilityArea = "r", // user can change responsibility area of other users..
  IgnoreResponsibilityArea = "ir", // ignore own responsibility area
  CanSeeSales = "s",
  CanSeeUserAndCompanies = "suc",
  CanSeeScenesAndOrders = "sso",
  CanEditTexts = "t",
  CanEditAssets = "m",
  CanEditArticles = "a",
  BeosImport = "b",
  CanEditOrderState = "bs",
  CanOrderSeriousError = "ose",
  CanViewNotes = "vn",
  ExternalImporter = "ei", // pina
  PushNotifications = "pn",
  SCSeeCarts = "scc"
}

export type AccessFeatures = PartialRecord<AccessFeature, number>;

export function getAccessFeatureString(af: AccessFeatures | undefined): string {
  if (!af) return "";
  const keys = Object.keys(af);
  const str = keys.sort((a, b) => a.localeCompare(b)).join(",");
  return str;
}

export function getAccessName(access: Access, af: AccessFeatures | undefined): string {
  return access + getAccessFeatureString(af);
}

export enum DealerType {
  RS = "RS", // Rollsegel
  SO = "SO", // Standard, Fixsegel
  SL = "SL", // Soliday Lounge
  ON = "ON", // not used ... Online
  RX = "RX", // Deleted?
}

export class DealerTypes {
  static All = [DealerType.RS, DealerType.SO, DealerType.SL, DealerType.ON, DealerType.RX];
}


export type UserType = "private" | "dealer";
export class UserTypes {
  static All: UserType[] = ["dealer", "private"];
}